import { Dispatch, SetStateAction, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'

import { accountIdSelector, clientSecretSelector } from 'features'
import { CheckoutForm } from './components'

interface IStripeComponentsProps {
  setAgreeCheck: Dispatch<SetStateAction<boolean>>
  agreeCheck: boolean
}
const StripeComponent = ({ setAgreeCheck, agreeCheck }: IStripeComponentsProps): JSX.Element | null => {
  const clientSecret = useSelector(clientSecretSelector)
  const accountId = useSelector(accountIdSelector)

  const options = useMemo(
    () => ({
      clientSecret,
      theme: 'stripe',
    }),
    [clientSecret]
  )

  const stripePromise = useMemo(
    () => loadStripe(process.env.REACT_APP_STRIPE_PK || '', { stripeAccount: accountId }),
    [accountId]
  )

  if (accountId && clientSecret) {
    return (
      <Elements options={options} stripe={stripePromise}>
        <CheckoutForm setAgreeCheck={setAgreeCheck} agreeCheck={agreeCheck} />
      </Elements>
    )
  }
  return null
}

export { StripeComponent }
